import { createSlice } from '@reduxjs/toolkit';
import { AuthStateProps } from '../../../Types/Auth.type';

const initialState: AuthStateProps = {
   isLoggedIn: false,
   isInitialized: false,
   user: null,
   roles: [],
   permissions: [],
};

const AuthSlice = createSlice({
   name: 'auth',
   initialState,
   reducers: {
      handleLogin: (state, action) => {
         state.isLoggedIn = true;
         state.isInitialized = true;
         state.user = action.payload;
      },
      handleLogout: (state) => {
         state.isLoggedIn = false;
         state.isInitialized = true;
         state.user = null;
      },
      handleRegister: (state, action) => {
         state.user = action.payload;
      },
      setRoles: (state, action) => {
         state.roles = action.payload;
      },
      setPermissions: (state, action) => {
         state.permissions = action.payload;
      },
   },
});

export const {
   handleLogin,
   handleLogout,
   handleRegister,
   setRoles,
   setPermissions,
} = AuthSlice.actions;
export default AuthSlice.reducer;
